.RACBContainer
    height: 40px
    position: relative
    display: flex
    flex-direction: row
    align-items: center
    gap: 4px
    border-radius: $globalButtonRounding
    overflow: hidden
    box-shadow: $globalButtonShadowPrimary rgba($globalSettingsBackgroundShadowColor,0.05), $globalButtonShadowSecondary rgba($globalSettingsBackgroundShadowColor,0.05)
    .RACBAmountButton
        width: 24px
        height: 100%
        display: flex
        justify-content: center
        align-items: center
        cursor: pointer
        overflow: hidden
        border-radius: $globalButtonRounding
        &:active
            padding-top: 1px
            outline: none
    .RACBControlContainer
        height: 26px
        margin-left: 4px
        gap: 2px
        display: flex
        flex-direction: row
    .RACBDisabled
        cursor: default
        &:active
            padding-top: 0
    .RACBAmountInput
        width: 28px
        height: 26px
        border-radius: $globalButtonRounding
        font-size: 14px
        text-align: center
        box-sizing: border-box
        outline: none
        border: none
        &:focus
            outline: none
        &:disabled
            &:focus
                outline: none
    .RACBAmountWaiting
        position: absolute
        top: 0
        bottom: 0
        left: 0
        right: 0
        opacity: 0.5
        cursor: wait
    .RACBDivider
        height: 24px
        width: 1px
        flex-shrink: 0
        opacity: 0.7
    .RACBTextButtonContainer
        height: 100%
        padding-left: 5px
        padding-right: 15px
        font-size: 14px
        display: flex
        flex-direction: row
        align-items: center
        justify-content: center
        flex-grow: 1
        box-sizing: border-box
        border-radius: $globalButtonRounding
    .RACBTextButtonActive
        cursor: pointer
        &:hover
            background: rgb($globalButtonBackgroundSecondary)
        &:active
            background: rgb($globalButtonBackgroundPrimary)
            transition: background 0s
    .RACBTextButtonNotAvailable
        background: rgb($globalButtonBackgroundTertiary)
        border: 0
        display: flex
        flex-direction: row
        gap: 10px
        padding: 15px
        stroke: rgb($globalSettingsFontSecondary)
        span
            flex-grow: 1
            text-align: center
.RACBNotAvailableContainer
    border: none
    box-shadow: none

.RACBDefaultColors
    background: rgb($globalSettingsBackgroundPrimary)
    color: rgb($globalSettingsFontPrimary)
    border: 1px solid rgb($globalSettingsStrokeSecondary)
    .RACBAmountButton
        stroke: rgb($globalSettingsFontSecondary)
    .RACBDisabled
        stroke: rgb($globalSettingsFontTertiary)
        background: rgb($globalSettingsBackgroundSecondary)
        &:active
            background: rgb($globalSettingsBackgroundSecondary)
        &:hover
            background: rgb($globalSettingsBackgroundSecondary)
    .RACBWaved
        &:hover
            background: rgb($globalSettingsBackgroundSecondary)
        &:active
            background: rgb($globalSettingsBackgroundPrimary)
    .RACBRemoveHover
        &:hover
            stroke: rgb($globalErrorBackground)
    .RACBRemove
        stroke: rgb($globalErrorBackground)
    .RACBAmountInput
        color: rgb($globalSettingsFontPrimary)
        background: rgb($globalSettingsBackgroundPrimary)
        &:focus
            background: rgb($globalSettingsBackgroundSecondary)
        &:hover
            background: rgb($globalSettingsBackgroundSecondary)
        &:disabled
            background: rgb($globalSettingsBackgroundSecondary)
            &:focus
                background: rgb($globalSettingsBackgroundSecondary)
            &:hover
                background: rgb($globalSettingsBackgroundSecondary)
    .RACBAmountWaiting
        background: rgb($globalSettingsBackgroundSecondary)
    .RACBDivider
        background: rgb($globalSettingsFontTertiary)
    .RACBTextButtonActive
        &:hover
            background: rgb($globalSettingsBackgroundSecondary)
        &:active
            background: rgb($globalSettingsBackgroundPrimary)
    .RACBTextButtonNotAvailable
        background: rgb($globalSettingsBackgroundTertiary)
        stroke: rgb($globalSettingsFontSecondary)

.RACBCtaColors
    background: rgb($globalButtonBackgroundPrimary)
    color: rgb($globalButtonFontPrimary)
    .RACBAmountButton
        stroke: rgb($globalButtonFontSecondary)
    .RACBDisabled
        stroke: rgb($globalButtonFontTertiary)
        background: rgb($globalButtonBackgroundSecondary)
        &:active
            background: rgb($globalButtonBackgroundSecondary)
        &:hover
            background: rgb($globalButtonBackgroundSecondary)
    .RACBWaved
        &:hover
            background: rgb($globalButtonBackgroundSecondary)
        &:active
            background: rgb($globalButtonBackgroundPrimary)
    .RACBRemove
        stroke: rgb($globalErrorBackground)
    .RACBAmountInput
        color: rgb($globalButtonFontPrimary)
        background: rgb($globalButtonBackgroundPrimary)
        &:focus
            background: rgb($globalButtonBackgroundSecondary)
        &:hover
            background: rgb($globalButtonBackgroundSecondary)
        &:disabled
            background: rgb($globalButtonBackgroundSecondary)
            &:focus
                background: rgb($globalButtonBackgroundSecondary)
            &:hover
                background: rgb($globalButtonBackgroundSecondary)
    .RACBAmountWaiting
        background: rgb($globalButtonBackgroundSecondary)
    .RACBDivider
        background: rgb($globalButtonFontTertiary)
    .RACBTextButtonActive
        &:hover
            background: rgb($globalButtonBackgroundSecondary)
        &:active
            background: rgb($globalButtonBackgroundPrimary)
    .RACBTextButtonNotAvailable
        background: rgb($globalButtonBackgroundTertiary)
        stroke: rgb($globalSettingsFontSecondary)

